requestAF = window.requestAnimationFrame or window.webkitRequestAnimationFrame
cancelAF  = window.cancelAnimationFrame  or window.webkitCancelAnimationFrame

class TimerModel extends Backbone.Model
  initialize: (@options) ->
    # Ensure that limit is an expected number
    @set("limit", -1) unless @hasLimit()
    @set("passed", 0)
    @set("isDisabled", @options.isDisabled or !@hasLimit())

    @on "start", @trackTimer, this
    @on "reset", @resetTimer, this
    @on "count", @countDown, this
    @on "change", @getTotal, this
    @on "stop", @endTimer, this

  resetTimer: ->
    @set
      bonus: 0
      total: @get("limit")
      remaining: @get("limit")
      paused: true

  # Track the game's time once it has started. All attributes can freely
  # affect the duration of the game, and pausing it will keep firing the timer
  # until it becomes unpaused
  trackTimer: ({callback}) ->
    if @hasLimit()
      @set
        start: Date.now() - (@get("total") - @get("remaining"))
        paused: false

      @clearTimers()

      do repeat = =>
        now = Date.now()

        {start, passed, limit, remaining, total, interval} = @attributes

        if @get("paused")
          @set start: now - (limit - remaining)

        else
          @set {
            remaining: Math.max(total - (now - start), 0),
            passed: now - start
          }

        if @get("remaining") > 0 or @get("isDisabled")
          @rafWrap = requestAF(repeat)

        else
          @timeout = window.setTimeout(callback, 300)

  clearTimers: ->
    cancelAF? @rafWrap
    window.clearTimeout @timeout

  endTimer: ->
    @clearTimers()
    @set paused: true

  # Before the game starts, count down from 3 x 1200ms
  countDown: ({callback, steps, ms}) ->
    if not @hasLimit()
      callback?()
    else
      @set paused: true
      count = steps or 3

      @clearTimers()

      do repeat = =>
        @set count: count

        if count is 0
          callback()
        else
          @timeout = window.setTimeout(repeat, ms or 1200)
          count--

  # When bonus time changes, ensure the total represents the limit + bonus
  getTotal: (e) ->
    unless e.changed.total
      @set total: @get("limit") + (@get("bonus") or 0)

  # Utility to check for a valid time limit, where the data may be undefined,
  # NaN, -1 or some other non-numeric value.
  hasLimit: ->
    @get("limit") > 0

  # Similar to set, this function allows an increase/decrease to numerical
  # attributes by an amount rather than getting and setting. Allows either
  # (key, val) or ({key, val}) syntax.
  setBy: (obj, amount) ->
    if typeof obj is "string"
      key = obj
      obj = {}
      obj[key] = amount

    for key, val of obj
      prev = @get(key)
      @set(key, prev + val)

      if key is "bonus" and val > 0
        @set({lastBonus: 0}, silent: true)
        @set(lastBonus: val)

  destroy: ->
    @clearTimers()
    super

module.exports = TimerModel
